import React, { useEffect, useRef, useState } from 'react';
import Productcard from './productcard';
import { Productcardskeleton } from '../Components/skeletons';


function ProductSlider({ products, showquantity, showoffer }) {



	return (
		<div className='wrapproductcards'>
			{products?.length > 0 ? products?.map((val, key) => {
				return (
					<Productcard product={val} key={key} showquantity={showquantity} showoffer={showoffer} />
				)
			}) :
				Array.from({ length: 20 }, (_, index) => (
					<Productcardskeleton key={index} />
				))
			}
		</div>
	);
}

export default React.memo(ProductSlider);
